import type { SVGProps } from "react";

export function IconVideoPlay(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="white"
      viewBox="0 0 30 38"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video play</title>
      <path d="M5 2 L27 19 L5 36 Z" />
    </svg>
  );
}
